import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

import { ReactiveFormsModule, FormsModule, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { map, startWith, take, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';


import { itemService } from '../../../helpers/services/main.service';
import { artPieceService } from '../../../helpers/services/art_piece.service';
import { ImageUploadComponent } from 'src/app/components/image-upload/image-upload.component';
import { TooltipDirective } from '../../ui/directives/tooltip.directive';
import { ItemLibraryModule } from '../../itemLibrary/itemLibrary.module';
import { LoaderService } from '../../../helpers/services/loader.service';

class merchGroup {
  id: number;
  title: string;
  mg_code: string;
  parent_id: number;
}
@Component({
  selector: 'app-new-art-piece',
  templateUrl: './newArtPiece.component.html',
  styleUrls: ['./newArtPiece.component.scss'],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatChipsModule,
    ImageUploadComponent,
    TooltipDirective,
    ItemLibraryModule
],
  standalone: true,
})

export class NewArtPieceComponent implements OnInit {

  selectedCompanyCode: any[] = [];
  companyCode: any = [];
  selectedDivisionCode: any = "";
  divisionCode: any = [];
  role: any;
  MG05: any[] = [];
  MG06: any[] = [];
  MG07: any[] = [];
  MG08: any[] = [];
  MG09: any[] = [];
  MG10: any[] = [];
  seasonptions: any[] = [];
  licensorOptions: any[] = [];
  propertyOptions: any[] = [];
  subformatOptions: any[] = [];
  styleguidOptions: any[] = [];
  formatOptions: any[] = [];
  artSourceOptions: any[] = [];
  littleThemeOptions: any[] = [];
  artistOptions: any[] = [];
  ageGroupOptions: any[] = [];
  bigthemeOptions: any[] = [];
  artTypeOptions: any[] = [];
  filteredOptions = {
    sizeOptions: [],
    seasonptions: [],
    licensorOptions: [],
    propertyOptions: [],
    styleguidOptions: [],
    artSourceOptions: [],
    littleThemeOptions: [],
    artistOptions: [],
    ageGroupOptions: [],
    bigthemeOptions: [],
    artTypeOptions: [],
  }
  merchgroups: any[] = [];
  art_description: any = "";
  imageLink: any = "";
  thumbImageLink: any = "";
  uploading: boolean = false;
  // Tags
  tags: string[] = [];
  readonly separatorKeysCodes: number[] = [ENTER];

  form = this.fb.group({
    seasonControl: new FormControl({ value: new merchGroup(), disabled: true }),
    licensorControl: new FormControl({ value: new merchGroup(), disabled: true }, Validators.required),
    styleguidControl: new FormControl({ value: new merchGroup(), disabled: true }),
    propertyControl: new FormControl({ value: new merchGroup(), disabled: true }, Validators.required),
    artSourceControl: new FormControl({ value: new merchGroup(), disabled: true }),
    bigthemeControl: new FormControl({ value: new merchGroup(), disabled: true }),
    littleThemeControl: new FormControl({ value: new merchGroup(), disabled: true }),
    artistControl: new FormControl({ value: new merchGroup(), disabled: true }),
    ageGroupControl: new FormControl({ value: new merchGroup(), disabled: true }),
    artTypeControl: new FormControl({ value: new merchGroup(), disabled: true })
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<NewArtPieceComponent>,
    public dialog: MatDialog,
    public itemService: itemService,
    public artPieceService: artPieceService,
    private _snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef,
    private loaderService: LoaderService
  ) {

  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private _filter(value: any, control: any): string[] {
    let searchString = '';
    if (typeof value === 'string') {
      searchString = value.toLowerCase();
    } else if (value && typeof value.title === 'string') {
      searchString = value.title.toLowerCase();
    } else if (value.seasonDesc) {
      searchString = value.seasonDesc.toLowerCase();
    } else if (value.name) {
      searchString = value.name.toLowerCase();
    }
    return control.filter(option => {
      if (option.seasonDesc) return option.seasonDesc.toLowerCase().includes(searchString)
      if (option.name) return option.name.toLowerCase().includes(searchString)
      return option.title.toLowerCase().includes(searchString)
    });
  }

  checkEmptyDivision() {
    Object.keys(this.form.controls).forEach(controlName => {
        this.form.controls[controlName].enable();
    });
  }

  async ngOnInit() {
    this.form.controls.seasonControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.seasonptions)),
    ).subscribe((data) => {
      this.filteredOptions.seasonptions = data;
    })

    this.form.controls.licensorControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.licensorOptions)),
    ).subscribe((data) => {
      this.filteredOptions.licensorOptions = data;
    })

    this.form.controls.styleguidControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.styleguidOptions)),
    ).subscribe((data) => {
      this.filteredOptions.styleguidOptions = data;
    })

    this.form.controls.propertyControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.filteredOptions.propertyOptions)),
    ).subscribe((data) => {
      this.filteredOptions.propertyOptions = data;
    })

    this.form.controls.artSourceControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.artSourceOptions)),
    ).subscribe((data) => {
      this.filteredOptions.artSourceOptions = data;
    })

    this.form.controls.bigthemeControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.bigthemeOptions)),
    ).subscribe((data) => {
      this.filteredOptions.bigthemeOptions = data;
    })

    this.form.controls.littleThemeControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.littleThemeOptions)),
    ).subscribe((data) => {
      this.filteredOptions.littleThemeOptions = data;
    })

    this.form.controls.artistControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.artistOptions)),
    ).subscribe((data) => {
      this.filteredOptions.artistOptions = data;
    })

    this.form.controls.ageGroupControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.ageGroupOptions)),
    ).subscribe((data) => {
      this.filteredOptions.ageGroupOptions = data;
    })

    this.form.controls.artTypeControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.artTypeOptions)),
    ).subscribe((data) => {
      this.filteredOptions.artTypeOptions = data;
    })

    try {
      const data: any = await this.itemService.getCompanyCode().toPromise();
      this.companyCode = data;
      const tempCodes = []
      data[0].divisionCodes.forEach((code) => {
          tempCodes.push(code)
      })
      this.divisionCode = tempCodes;
    } catch (err) {
      console.error('[NewArtPiece] getCompanyCode failed:', err);
    }
    
    this.itemService.getSeasonCode().subscribe(async (res: any) => {
      res.data.forEach((season) => this.seasonptions.push(season))
    })

    this.form.controls.licensorControl.valueChanges.subscribe(value => {
      if (!value) {
        this.filteredOptions.propertyOptions = [];
        this.form.controls.propertyControl.reset();
        this.form.controls.propertyControl.disable();
      } else {
        this.form.controls.propertyControl.enable();
      }
    });

    this.form.controls.propertyControl.valueChanges.pipe(
      debounceTime(10), // Wait for 300ms pause in typing
      distinctUntilChanged() // Only emit if value changed
    ).subscribe(value => {
      if(!value) {
        // When second box is cleared, reload options based on first box
        const selectedLicenseTitle = this.form.controls.licensorControl.value;
        if (selectedLicenseTitle) {
          this.getPropertyByLicense(selectedLicenseTitle);
        } else {
          // Corrected from productSubSubTypeOptions to propertyOptions
          this.filteredOptions.propertyOptions = [];
        }
      }
    });
  }

  onDivisionChange(selected: any) {
    // Start loader when division changes
    this.loaderService.increment();
    
    this.selectedDivisionCode = selected.value;
    this.getMerchGroups(selected);
    this.checkEmptyDivision();
    this.resetFields();

    if (this.selectedDivisionCode?.divCode_id === 9) {
      this.form.controls['bigthemeControl'].setValidators(Validators.required);
      this.form.controls['littleThemeControl'].setValidators(Validators.required);
    
      this.form.controls['licensorControl'].clearValidators();
      this.form.controls['propertyControl'].clearValidators();
    } else {
      this.form.controls['bigthemeControl'].clearValidators();
      this.form.controls['littleThemeControl'].clearValidators();
    
      this.form.controls['licensorControl'].setValidators(Validators.required);
      this.form.controls['propertyControl'].setValidators(Validators.required);
    }
    
    // Update validity for all
    ['bigthemeControl', 'littleThemeControl', 'licensorControl', 'propertyControl']
      .forEach(ctrl => this.form.controls[ctrl].updateValueAndValidity());
  }

  async getMerchGroups(selectedDivisionCode: any) {
    this.licensorOptions = []
    this.propertyOptions = []
    this.styleguidOptions = []
    this.artSourceOptions = []
    this.littleThemeOptions = []
    this.bigthemeOptions = []
    this.ageGroupOptions = []
    this.artTypeOptions = []
    this.artistOptions = []

    this.itemService.getMerchGroup({ divisionCode: [selectedDivisionCode.value.divCode_id], DivisionStatus: 1 }).subscribe(async (data: any) => {
      for (var i = 0; data.length > i; i++) {
        for (var j = 0; data[i].merchGroupHeaders.length > j; j++) {
          this.merchgroups = data[i]
            if (data[i].merchGroupHeaders[j].mgTypeDesc == "Licensor") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
                this.licensorOptions.push({ 
                  title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, 
                  id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, 
                  mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code, 
                  parent_id: data[i].merchGroupHeaders[j].merchGroups[k].parent_id
                })
            }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Property") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
              this.propertyOptions.push({ 
                title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, 
                id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, 
                mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code, 
                parent_id: data[i].merchGroupHeaders[j].merchGroups[k].parent_id 
              })
            }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Little Theme") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
              this.littleThemeOptions.push({ title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code })
            }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Big Theme") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
              this.bigthemeOptions.push({ title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code })
            }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Style guide") {
              for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
                this.styleguidOptions.push({ title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code })
              }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Art Type") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
              if (data[i].merchGroupHeaders[j].merchGroups[k].is_active) {
                this.artTypeOptions.push({ title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code })
              }
            }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Art Source") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
              if (data[i].merchGroupHeaders[j].merchGroups[k].is_active) {
                this.artSourceOptions.push({ title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code })
              }
            }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Artist") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
              if (data[i].merchGroupHeaders[j].merchGroups[k].is_active) {
                this.artistOptions.push({
                  title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc,
                  id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id,
                  mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code
                })
              }
            }
          } else if (data[i].merchGroupHeaders[j].mgTypeDesc == "Age Group") {
            for (var k = 0; data[i].merchGroupHeaders[j].merchGroups.length > k; k++) {
              if (data[i].merchGroupHeaders[j].merchGroups[k].is_active) {
                this.ageGroupOptions.push({ title: data[i].merchGroupHeaders[j].merchGroups[k].mg_desc, id: data[i].merchGroupHeaders[j].merchGroups[k].mg_id, mg_code: data[i].merchGroupHeaders[j].merchGroups[k].mg_code })
              }
            }
          }
        }
        this.filteredOptions.artSourceOptions = this.customSort(this.artSourceOptions);
        this.filteredOptions.bigthemeOptions = this.customSort(this.bigthemeOptions);
        this.filteredOptions.artistOptions = this.customSort(this.artistOptions);
        this.filteredOptions.licensorOptions = this.customSort(this.licensorOptions);
        this.filteredOptions.littleThemeOptions = this.customSort(this.littleThemeOptions);
        this.filteredOptions.propertyOptions = this.customSort(this.propertyOptions);
        this.filteredOptions.seasonptions = this.seasonptions.sort((a, b) => a?.seasonCode.toLowerCase().localeCompare(b?.seasonCode.toLowerCase()));
        this.filteredOptions.styleguidOptions = this.customSort(this.styleguidOptions);
        this.filteredOptions.ageGroupOptions = this.customSort(this.ageGroupOptions);
        this.filteredOptions.artTypeOptions = this.customSort(this.artTypeOptions); 
      }
      // Decrement loader after merch groups are loaded
      this.loaderService.decrement();
    }, (error) => {
      // Decrement loader on error
      this.loaderService.decrement();
    })
  }

  customSort(field) {
    return field.sort((a, b) => 
      {
        const valA = a?.mgCode2 || a?.mg_code || a?.title || a?.name;
        const valB = b?.mgCode2 || b?.mg_code || b?.title || b?.name;
        return valA?.toLowerCase().localeCompare(valB?.toLowerCase());
      });
  }

  async onCreateNewArtPiece() {
    if (!this.selectedDivisionCode)
      return this._snackBar.open('Please select a division', 'close');

    if (!this.form.valid)
      return this._snackBar.open('Please complete all required fields.', 'close');

    if (!this.art_description || !this.art_description.trim()) {
      return this._snackBar.open('Art Description is required.', 'close');
    }
    
    if (this.art_description.length > 100) {
      return this._snackBar.open('Art Description cannot exceed 100 characters.', 'close');
    }

    // All validations passed → proceed
    this.uploading = true;
    await this.requestCreateArtPiece();
  }

  async requestCreateArtPiece() {
    // Start loader when creating art piece
    this.loaderService.increment();
  
    const artPieceData = {
      art_description: this.art_description,
      season_code_id: this.form.controls.seasonControl.value?.id,
      licensor_id: this.form.controls.licensorControl.value?.id,
      property_id: this.form.controls.propertyControl.value?.id,
      style_guide_id: this.form.controls.styleguidControl.value?.id,
      art_source_id: this.form.controls.artSourceControl.value?.id,
      big_theme_id: this.form.controls.bigthemeControl.value?.id,
      little_theme_id: this.form.controls.littleThemeControl.value?.id,
      artist_id: this.form.controls.artistControl.value?.id,
      age_group_id: this.form.controls.ageGroupControl?.value?.id,
      art_type_id: this.form.controls.artTypeControl.value?.id,
      divisioncode_id: this.selectedDivisionCode.divCode_id,
      selectedDivisionCode: this.selectedDivisionCode,
      company_code: this.companyCode[0]?.comCode_id,
      imageLink: this.imageLink,
      thumbImageLink: this.thumbImageLink,
      tags: this.tags,
      art_number: ''
    }

    artPieceData.art_number = this.generateArtNumber();

    this.artPieceService.createItem(artPieceData).subscribe({
      next: async (res: any) => {
        this.uploading = false; 
    
        if (res.statusCode === 200) {
          this._snackBar.open(`Art Piece ${res.art_number} was created successfully`, 'close'); 
          // Decrement loader after art piece is created successfully
          this.loaderService.decrement();
          this.dialogRef.close({data: artPieceData});
        } else {
          this._snackBar.open('Unable to create the Art Piece', 'close');
          // Decrement loader on error
          this.loaderService.decrement();
        }
      },
      error: (err) => {
        this.uploading = false;
        this._snackBar.open('Unable to create the Art Piece due to server/network error', 'close');
        // Decrement loader on error
        this.loaderService.decrement();
      }
    });
  }

  generateArtNumber(): string {
    // Format: Division-Licensor-Property or 
    //         Division-BigTheme-LittleTheme   
    const divisionCode = this.selectedDivisionCode.divCode_id;
  
    const divisionLetter = divisionCode === 1 ? 'P' :
                           divisionCode === 8 ? 'S' :
                           divisionCode === 9 ? 'G' :
                           '';

    const licensor = this.form.controls.licensorControl.value?.mg_code || '';
    const property = this.form.controls.propertyControl.value?.mg_code || '';
    const bigTheme = this.form.controls.bigthemeControl.value?.mg_code || '';
    const littleTheme = this.form.controls.littleThemeControl.value?.mg_code || '';

    if (divisionCode === 9) {
      return `${divisionLetter}${bigTheme}${littleTheme}`
    }
  
    return `${divisionLetter}${licensor}${property}`
  }
  
  onLicensorSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedTitle = event.option.value.title;
    this.getPropertyByLicense(selectedTitle)
  }

  getPropertyByLicense(selectedTitle){
    this.filteredOptions.propertyOptions = []

    const selectedLicense = this.licensorOptions.find(
      option => option.title === selectedTitle
    );

    if (selectedLicense) {
      const licenseId = selectedLicense.id;
      this.filteredOptions.propertyOptions = this.propertyOptions
        .filter(property => property.parent_id === Number(licenseId))
    }
  }

  displayOptionTitle(option: any): string {
    return option?.seasonDesc || option?.title || option?.name || '';
  }

  resetFields(fromResetButton: boolean = false) {
    // Reset form controls
    this.form.reset();
    
    // Reset other fields
    this.art_description = '';
    this.imageLink = '';
    this.thumbImageLink = '';
    this.tags = [];
  
    if (fromResetButton) {
      this.selectedDivisionCode = ''; // ✅ clear only on reset button
    }
  }

  onUploadComplete(event: {sharedLink: string, thumbSharedLink: string}) {
    if (event) {
      this.imageLink = event.sharedLink;
      this.thumbImageLink = event.thumbSharedLink;
      this._snackBar.open("File Uploaded Successfully", "ok", {
        duration: 3000,
      });
    }
  }

  onTagInput(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.tags.push(value);
    }
    if (event.input) {
      event.input.value = '';
    }
  }
} 